// 1. Define a branded type
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export type Code15 = string & { __brand: 'Code15' };

// 2. Create a validator to ensure correctness at runtime
export function isCode15(value: string): value is Code15 {
  return /^\d{15}$/.test(value);
}

export function code15Validator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {return null;} // don't validate empty
    return isCode15(value) ? null : { invalidCode15: true };
  };
}
